<template>
  <div class="supply_content_sty">
    <div class="stem" :class="'one-' + question.questionId">
      <span class="index">{{ idx }}.</span>
      <span class="type">({{ checkType(question.type) }})</span>
      <p class="question_title" v-html="question.question"></p>
      <b class="question_score">{{ question.score }}分</b>
      <b class="grade" v-show="alreadyDo && question.myScore"
        >得分：{{ question.myScore }}分</b
      >
    </div>
    <div class="question_answer_content_sty">
      <div
        class="question_answer_content_item_sty"
        v-for="(i, index) in question.myAnswerList"
        :key="index"
      >
        <div class="question_answer_content_item_index_sty">
          {{ index + 1 }}
        </div>
        <div class="question_answer_content_item_input_sty">
          <el-input
            placeholder="请输入答案"
            v-model="i[`answer${index + 1}`]"
            :disabled="alreadyDo"
            clearable
          >
          </el-input>
        </div>
      </div>
    </div>
    <p class="answer-row" v-if="!hideAnswer && question.answerList">
      正确答案：{{ question.answerList.join(",") }}
    </p>
  </div>
</template>

<script>
import { checkType } from "@/utils/index";

export default {
  data() {
    return {
      checkType,
      myAnswerList: [],
      isShowClean: false,
      value: "",
    };
  },
  props: {
    // 索引
    idx: {
      type: Number,
      default: null,
    },
    // 题目对象
    question: {
      type: Object,
      default: function () {
        return {};
      },
    },
    alreadyDo: Boolean,
    hideAnswer: Boolean,
  },
  created() {
    let haveAnswer = !!this.question.myAnswerList;
    let num = this.question.emptyCount ? this.question.emptyCount : 0;
    let list = [];
    if (num !== 0) {
      for (let i = 0; i < num; i++) {
        let obj = {};
        obj[`answer${i + 1}`] = haveAnswer ? this.question.myAnswerList[i] : "";
        list.push(obj);
      }
    }
    this.question.myAnswerList = list;
  },
};
</script>


<style lang="less" scoped>
.stem {
  position: relative;
  margin: 20px 0;
  .index {
    display: inline-block;
    margin-top: 3px;
    vertical-align: top;
  }
  .type {
    display: inline-block;
    margin: 0 5px;
    color: #969696;
    vertical-align: top;
  }
  .question_title {
    display: inline-block;
    max-width: 83%;
    font-size: 16px;
    color: #333;
    vertical-align: top;
  }
  .question_score {
    display: inline-block;
    margin-left: 10px;
    color: #999;
    font-size: 14px;
    vertical-align: top;
  }
  .grade {
    position: absolute;
    top: 0;
    right: -20px;
    color: #ff0000;
  }
}
.question_answer_content_sty {
  width: 100%;
  .question_answer_content_item_sty {
    width: 100%;
    height: 38px;
    &:not(:first-child) {
      margin-top: 20px;
    }
    & > div {
      display: inline-block;
      vertical-align: top;
    }
    .question_answer_content_item_index_sty {
      width: 41px;
      height: 100%;
      background: #e6e6e6;
      text-align: center;
      line-height: 38px;
    }
    .question_answer_content_item_input_sty {
      width: calc(100% - 41px);
      height: 38px;
      line-height: 38px;
      position: relative;
      border: 1px solid #e6e6e6;
      & > input {
        width: 100%;
        padding-left: 10px;
        box-sizing: border-box;
      }
      ::v-deep .el-input__inner {
        border: none !important;
        height: 34px;
        line-height: 34px;
      }
      & > i {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        color: #bdbdbd;
      }
    }
  }
}

.answer-row {
  margin-top: 10px;
  color: #67c23a;
}
</style>